import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const prefix = (icon) =>
  ["google", "wikipedia-w", "microsoft"].includes(icon) ? "fab" : "fa";

const FA = ({ icon, ...props }) => (
  <FontAwesomeIcon {...props} icon={[prefix(icon), icon]} />
);

export { FA };
